import { trackClientEvent } from '../../../../trackClientEvent';
export var eventKey = 'brand_preview-faires_arrangement_link-click';
/**
 * Tracks clicks on cta to Faire&#39;s Arrangement loom video
 */ export function trackBrandPreviewFairesArrangementLinkClick() {
    return trackClientEvent({
        eventKey: eventKey,
        realTimeTracking: false
    });
}
